import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f2dda16a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=f2dda16a&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=f2dda16a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dda16a",
  null
  
)

export default component.exports